import { useEffect, useRef, useState } from "react";
import { getAllCategories } from "services/category.service";
import { handleApiResponse } from "services/helper-function.service";
import CategoryTemplate from "templates/CategoryTemplate";

const fetcherCategories = async (name) => {
    const res = await getAllCategories(name);
    const { details, apiError } = await handleApiResponse(res);
    return { details, apiError };
};

export default function index({ details, apiErrors }) {
    const categories = [{ name: "ALL", image: "/images/category-1.svg" }, ...details];
    const didMount = useRef(false);
    const [category, setCategory] = useState();
    const [allCategories, setAllCategories] = useState(details);

    useEffect(() => {
        if (didMount.current) {
            fetchCategories(category);
        }
        didMount.current = true;
    }, [category]);

    const fetchCategories = async (name) => {
        const { details } = await fetcherCategories(name);
        setAllCategories(details);
    };

    return <>{apiErrors.length === 0 && <CategoryTemplate categories={categories} setCategory={setCategory} allCategories={allCategories} />}</>;
}

export const getServerSideProps = async () => {
    const { details, apiError } = await fetcherCategories("");
    return { props: { details, apiErrors: apiError } };
};
